site.contentImage = {
	figcaption: function() {
		$('.entryContent').find("img[title]").each(function () {
			var $this = $(this),
				caption = $this.attr('title');
			if (caption !== '' && caption !== undefined) {
				var imgClass = $this.attr('class');
				$this.wrap('<figure />');
				var $figure = $this.closest('figure');

				if (imgClass) {
					$figure.addClass(imgClass);
					$this.removeAttr('class');
				}
				$("<figcaption>" + caption + "</figcaption>").insertAfter(this);

				/*
				$('figcaption', $figure).css({
					'max-width' : $this.width(),
				});
				*/

			}
		});
	},

	fancyGallery: function() {
		$('img[src*="/static/gallery"]', '.entryContent').each(function() {
			var imgsrc = $(this).attr('src').replace('/xs/', '/lg/');
			$(this).wrap('<a href="'+imgsrc+'" class="fancybox" data-fancybox-title="' + $(this).attr('title') +'"' +
				' data-fancybox-group="fancy" />')
		});
	}
};
